import {
  Grid,
  TableCell,
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableContainer,
  Paper,
  Dialog,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  DialogContent,
  DialogContentText,
  Link
} from '@material-ui/core';
import React, { Component } from 'react';
import PageHeader from '../common/PageHeader';
import { apiBatchRequest, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import _ from 'lodash';
import Reports from './Reports';
import './report.less';
import moment from 'moment';
import { DateFormat, DateFormatMMDDYYYY } from '../../constants/appConstants';
import ReportButtons from './ReportButtons';
import {
  EnhancedTableHead,
  GenerateAbsoluteURL,
  getLast3PayPeriodData,
  IsSensitiveDataAccess,
  numberWithCommas,
  orderBy,
  removeDuplicates,
  with2DecimalsPoints
} from '../../utils/helper';
import { getFormattedValues } from '../../utils/formatData';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import TableWithPaginations from './TableWithPaginations';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { collapsableAllocationPercent, collapsableReimbursement, extendibleMarkerReimbursArray } from '../../constants/MockData';
import { getMultilevelGroupedData } from '../../utils/generic';
import AdvancedFilter from './AdvancedFilter';

let defaultPayPeriod = [];

export default class MarketVarianceDetalis extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMain: false,
      marketMasterData: [],
      marketReimburseData: [],
      empSummaryRows: [],
      showReport: false,
      openSlidingPanel: false,
      printPage: false,
      lastPayPeriod: [],
      isPopupOpen: false,
      employeeSummary: [],
      confirmationMessage: '',
      msgTitle: '',
      row: [],
      order: 'asc',
      orderBy: 'nam',
      advanceFilterConfig: {
        groupBy: {
          masterData: [
            {
              key: 'Department',
              id: 'departmentName',
              value: 'departmentName',
              ssrsReport: 'DepartmentName',
              numeric: false,
              disablePadding: false,
              label: 'Department',
              type: 'Text',
              order: 2
            },
            {
              key: 'Division',
              id: 'division',
              value: 'division',
              ssrsReport: 'Division',
              numeric: false,
              disablePadding: false,
              label: 'Division',
              type: 'Text',
              order: 3
            },
            {
              key: 'Employee',
              value: 'employeeName',
              id: 'employeeName',
              ssrsReport: 'Employee',
              numeric: false,
              disablePadding: false,
              label: 'Employee',
              type: 'Text',
              order: 4
            },
            {
              key: 'Expense Group',
              value: 'expenseGroup',
              id: 'expenseGroup',
              ssrsReport: 'ExpenseGroup',
              numeric: false,
              disablePadding: false,
              label: 'Expense Group',
              type: 'Text',
              order: 5
            },
            {
              key: 'Expense Name',
              value: 'expenseName',
              id: 'expenseName',
              ssrsReport: 'ExpenseName',
              numeric: false,
              disablePadding: false,
              label: 'Expense Name',
              type: 'Text',
              order: 6
            }],
          selected: [{
            key: 'Market',
            value: 'marketName',
            id: 'marketName',
            ssrsReport: 'MarketName',
            numeric: false,
            disablePadding: false,
            label: 'Market',
            type: 'Text',
            order: 1
          }]
        },
        selectedDate: {},
        suppressGraph: false,
        suppressZero: true,
        summaryRows: true,
        suppressDetails: false,
        showZeroNGraph: true
      }
    };
    this.baseState = this.state;
  }

  componentDidMount() {
    this.GetMarketReimburseData();
  }

  goBack = () => {
    this.setState({
      showMain: true
    });
  };

  handleClose = () => {
    this.setState({
      openSlidingPanel: false
    });
  };

  handlePrintClick = () => {
    this.handleExport('application/pdf', 'Pdf', true);
  };

  GetMarketReimburseData = (ssrsCall = 5) => {
    const date = getLast3PayPeriodData();
    const params = {
      fromDate: moment(date[0]).format(DateFormat),
      toDate: moment(date[1]).format(DateFormat),
      ssrsCall: ssrsCall
    };
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Report.GetMarketVaianceDetailData,
        params,
        key: 'marketReimburseData'
      }
    ])
      .then(({ marketReimburseData }) => {
        this._asyncRequest = null;
        if (marketReimburseData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        const empSummaryRows = this.getTableRow(marketReimburseData.data, marketReimburseData.config,
          marketReimburseData.rawData.find(x => x === true) !== undefined);
        this.setState({
          marketReimburseData: marketReimburseData.data,
          empSummaryRows,
          showReport: true,
          lastPayPeriod: marketReimburseData.config,
          showLink: marketReimburseData.rawData.find(x => x === true) !== undefined
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  renderTableCell = (groupedData, payPeriod, showLink) => {
    const tableCell = [];
    let evenOddClass = '';
    let reimbursementCostPayPeriod2 = 0; let reimbursementCostPayPeriod3 = 0; let variancePercent = 0;

    groupedData.forEach((d, i) => {
      evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      tableCell.push(
        <TableRow key={i} className={evenOddClass}>
          <TableCell className={
            evenOddClass + 'st sticky'
          }>
            {getFormattedValues(d.marketName, 'Text')}{' '}
          </TableCell>
          {payPeriod.map((pay, payIndex) => {
            return (<TableCell key={i + payIndex} className={
              evenOddClass + 'st sticky-' + (payIndex + 1)
            }>
              {getFormattedValues(d['reimbursementCost_' + pay.payPeriod], 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}
            </TableCell>);
          })
          }
          <TableCell className={
            evenOddClass + 'st sticky-4'
          }>
            {getFormattedValues(d.currentVariance, 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}
          </TableCell>
          <TableCell className={
            evenOddClass + 'st sticky-5'
          }>
            {getFormattedValues(d.variancePercent, 'DecimalPercent', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}
          </TableCell>
          {payPeriod.map((pay, payIndex) => {
            return (<TableCell key={i + payIndex} className={
              evenOddClass
            }>
              { (IsSensitiveDataAccess() && showLink === true && d['billableCount_' + pay.payPeriod] > 0)
                ? <Link className='anchor-decoration' onClick={() => { this.onPopupClickHandle(true, d, pay.periodStartDate, pay.periodEndDate, 'Count of Allocations', 'Employee', 'allocations'); }} style={{ cursor: 'pointer' }}>
                  {getFormattedValues(d['billableCount_' + pay.payPeriod], 'Number')}
                </Link>
                : getFormattedValues(d['billableCount_' + pay.payPeriod], 'Number')}{' '}
            </TableCell>);
          })
          }
          {payPeriod.map((pay, payIndex) => {
            return (<TableCell key={i + payIndex} className={
              evenOddClass
            }>
              { (IsSensitiveDataAccess() && showLink === true && d['newEmployee_' + pay.payPeriod] > 0)
                ? <Link className='anchor-decoration' onClick={() => { this.onPopupClickHandle(true, d, pay.periodStartDate, pay.periodEndDate, 'Count of New Allocations', 'Employee', 'newEmployee'); }} style={{ cursor: 'pointer' }}>
                  {getFormattedValues(d['newEmployee_' + pay.payPeriod], 'Number')}
                </Link>
                : getFormattedValues(d['newEmployee_' + pay.payPeriod], 'Number')}{' '}

            </TableCell>);
          })
          }
          {payPeriod.map((pay, payIndex) => {
            return (<TableCell key={i + payIndex} className={
              evenOddClass
            }>
              { (IsSensitiveDataAccess() && showLink === true && d['terminatedEmployees_' + pay.payPeriod] > 0)
                ? <Link className='anchor-decoration' onClick={() => { this.onPopupClickHandle(true, d, pay.periodStartDate, pay.periodEndDate, 'Count of Terminated Allocations', 'Employee', 'terminatedEmployees'); }} style={{ cursor: 'pointer' }}>
                  {getFormattedValues(d['terminatedEmployees_' + pay.payPeriod], 'Number')}
                </Link>
                : getFormattedValues(d['terminatedEmployees_' + pay.payPeriod], 'Number')}{' '}

            </TableCell>);
          })
          }
          {payPeriod.map((pay, payIndex) => {
            return (<TableCell key={i + payIndex} className={
              evenOddClass
            }>
              { (IsSensitiveDataAccess() && showLink === true && d['tenantCount_' + pay.payPeriod] > 0)
                ? <Link className='anchor-decoration' onClick={() => { this.onPopupClickHandle(true, d, pay.periodStartDate, pay.periodEndDate, 'Count of AR Teants', 'Employee', 'teantsCount'); }} style={{ cursor: 'pointer' }}>
                  {getFormattedValues(d['tenantCount_' + pay.payPeriod], 'Number')}
                </Link>
                : getFormattedValues(d['tenantCount_' + pay.payPeriod], 'Number')}{' '}

            </TableCell>);
          })
          }
          {payPeriod.map((pay, payIndex) => {
            return (<TableCell key={i + payIndex} className={
              evenOddClass
            }>
              { (IsSensitiveDataAccess() && showLink === true && d['propertyCount_' + pay.payPeriod] > 0)
                ? <Link className='anchor-decoration' onClick={() => { this.onPopupClickHandle(true, d, pay.periodStartDate, pay.periodEndDate, 'Count of AR Properties', 'Employee', 'arProperties'); }} style={{ cursor: 'pointer' }}>
                  {getFormattedValues(d['propertyCount_' + pay.payPeriod], 'Number')}
                </Link>
                : getFormattedValues(d['propertyCount_' + pay.payPeriod], 'Number')}{' '}

            </TableCell>);
          })
          }
          {payPeriod.map((pay, payIndex) => {
            return (<TableCell key={i + payIndex} className={
              evenOddClass
            }>
              {getFormattedValues(d['reimbursementAmount_' + pay.payPeriod], 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}
            </TableCell>);
          })
          }
        </TableRow>
      );
    });
    evenOddClass =
      tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
    tableCell.push(
      <TableRow className={evenOddClass}>
        <TableCell className={
          evenOddClass + 'st sticky'
        }>
          <b> {getFormattedValues('Total', 'Text')}{' '}</b>
        </TableCell>
        {payPeriod.map((pay, payIndex) => {
          if (payIndex === 1) {
            reimbursementCostPayPeriod2 = groupedData.reduce((total, obj) => (parseFloat(obj['reimbursementCost_' + pay.payPeriod]) + parseFloat(total)), 0);
          } else if (payIndex === 2 && reimbursementCostPayPeriod2 > 0) {
            reimbursementCostPayPeriod3 = groupedData.reduce((total, obj) => (parseFloat(obj['reimbursementCost_' + pay.payPeriod]) + parseFloat(total)), 0);
            variancePercent = ((reimbursementCostPayPeriod3 - reimbursementCostPayPeriod2) / (reimbursementCostPayPeriod2 === 0 ? null : reimbursementCostPayPeriod2)) * 100;
          }
          return (<TableCell key={payIndex} className={
            evenOddClass + 'st sticky-' + (payIndex + 1)
          }>
            <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['reimbursementCost_' + pay.payPeriod]) + parseFloat(total)), 0), 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}</b>
          </TableCell>);
        })
        }
        <TableCell className={
          evenOddClass + 'st sticky-4'
        }>
          <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj.currentVariance) + parseFloat(total)), 0), 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}</b>
        </TableCell>
        <TableCell className={
          evenOddClass + 'st sticky-5'
        }>
          <b>{getFormattedValues(variancePercent, 'DecimalPercent', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}</b>

        </TableCell>
        {payPeriod.map((pay, payIndex) => {
          return (<TableCell key={payIndex} className={
            evenOddClass
          }>
            <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['billableCount_' + pay.payPeriod]) + parseFloat(total)), 0), 'Number')}{' '}</b>

          </TableCell>);
        })
        }
        {payPeriod.map((pay, payIndex) => {
          return (<TableCell key={payIndex} className={
            evenOddClass
          }>
            <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['newEmployee_' + pay.payPeriod]) + parseFloat(total)), 0), 'Number')}{' '}</b>
          </TableCell>);
        })
        }
        {payPeriod.map((pay, payIndex) => {
          return (<TableCell key={payIndex} className={
            evenOddClass
          }>
            <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['terminatedEmployees_' + pay.payPeriod]) + parseFloat(total)), 0), 'Number')}{' '}</b>
          </TableCell>);
        })
        }
        {payPeriod.map((pay, payIndex) => {
          return (<TableCell key={payIndex} className={
            evenOddClass
          }>
            <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['tenantCount_' + pay.payPeriod]) + parseFloat(total)), 0), 'Number')}{' '}</b>
          </TableCell>);
        })
        }
        {payPeriod.map((pay, payIndex) => {
          return (<TableCell key={payIndex} className={
            evenOddClass
          }>
            <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['propertyCount_' + pay.payPeriod]) + parseFloat(total)), 0), 'Number')}{' '}</b>
          </TableCell>);
        })
        }
        {payPeriod.map((pay, payIndex) => {
          return (<TableCell key={payIndex} className={
            evenOddClass + 'st sticky-' + (payIndex + 1)
          }>
            <b>{getFormattedValues(groupedData.reduce((total, obj) => (parseFloat(obj['reimbursementAmount_' + pay.payPeriod]) + parseFloat(total)), 0), 'MoneyDecimal', false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}{' '}</b>
          </TableCell>);
        })
        }
      </TableRow>
    );
    return tableCell;
  };

  getTableRow = (marketReimburseData, payPeriod, showLink) => {
    let returnRows = [];

    returnRows = [...returnRows, ...this.renderTableCell(
      orderBy(marketReimburseData, this.state.orderBy, this.state.order),
      payPeriod,
      showLink
    )];
    return returnRows;
  }

  renderTable = (empSummaryRows) => {
    const { lastPayPeriod } = this.state;

    return (
      <Table className="reportTable" id="rptTable" key="rptTable">
        <TableHead>
          <TableRow className='background-table-header'>
            <TableCell colSpan={6} className='right-border'>
            </TableCell>
            <TableCell colSpan={9} align='center' className='right-border'>
              Reason for Variance
                </TableCell>
            <TableCell align='center' colSpan={9}>
              Reason for Variance
                </TableCell>
          </TableRow>
          <TableRow className='background-table-header'>
            <TableCell className='st sticky right-border'>
            </TableCell>
            <TableCell align='center' className='st sticky-1 right-border' colSpan={5}>
              Reimbursement Cost
                </TableCell>
            <TableCell align='center' className='right-border' colSpan={3}>
              Count of Allocations
                </TableCell>
            <TableCell align='center' className='right-border' colSpan={3}>
              Count of New Allocations
                </TableCell>
            <TableCell align='center' className='right-border' colSpan={3}>
              Count of Terminated Allocations
                </TableCell>
            <TableCell align='center' className='right-border' colSpan={3}>
              Count of AR Tenant
                </TableCell>
            <TableCell align='center' className='right-border' colSpan={3}>
              Count of AR Properties
                </TableCell>
            <TableCell align='center' className='right-border' colSpan={3}>
              AR Reimbursement Amount
                </TableCell>
          </TableRow>
          <TableRow className='background-table-header'>
            <TableCell className='st sticky right-border'>Market Name</TableCell>
            {lastPayPeriod.map((x, i) => {
              return (
                <TableCell className={'st sticky-' + (i + 1)} key={i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
              );
            })}
            <TableCell className='st sticky-4'>Current Variance ($)</TableCell>
            <TableCell className='st sticky-5 right-border'>Current Variance (%)</TableCell>
            {lastPayPeriod.map((x, i) => {
              return (
                <TableCell className={i === 2 ? 'right-border' : ''} key={i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
              );
            })}
            {lastPayPeriod.map((x, i) => {
              return (
                <TableCell className={i === 2 ? 'right-border' : ''} key={i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
              );
            })}
            {lastPayPeriod.map((x, i) => {
              return (
                <TableCell className={i === 2 ? 'right-border' : ''} key={i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
              );
            })}
            {lastPayPeriod.map((x, i) => {
              return (
                <TableCell className={i === 2 ? 'right-border' : ''} key={i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
              );
            })}
            {lastPayPeriod.map((x, i) => {
              return (
                <TableCell className={i === 2 ? 'right-border' : ''} key={i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
              );
            })}
            {lastPayPeriod.map((x, i) => {
              return (
                <TableCell className={i === 2 ? 'right-border' : ''} key={i}>{getFormattedValues(x.periodEndDate, 'Date')}</TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>{empSummaryRows}</TableBody>
      </Table>
    );
  };

  handleExport = (fileMimeType, type, isPrint) => {
    this.downloadFile(fileMimeType, type, isPrint);
  }

  downloadFile = (fileMimeType, type, isPrint) => {
    const date = getLast3PayPeriodData();
    const dataValue = [
      { key: 'StartDate', value: moment(date[0]).format(DateFormat) },
      { key: 'EndDate', value: moment(date[1]).format(DateFormat) }
    ];
    const url = GenerateAbsoluteURL(dataValue, [], 'Market%20Variance%20Detail%20Report', type);
    downloadReport(
      url,
      'Market Variance Details Report',
      fileMimeType,
      type,
      isPrint
    );
  }

  onPopupClickHandle = (value, data, FromDate, ToDate, msg, selected, type) => {
    if (value) {
      const advanceFilterConfig = this.state.advanceFilterConfig;
      const selectedMenu = advanceFilterConfig.groupBy.masterData.find(x => x.label === selected);
      if (selectedMenu !== undefined) {
        advanceFilterConfig.groupBy.masterData = ((advanceFilterConfig.groupBy || {})
          .masterData || []).filter(x => x.value !== selectedMenu.value);
        advanceFilterConfig.groupBy.selected = ((advanceFilterConfig.groupBy || {})
          .selected || []).filter(x => x.value !== selectedMenu.value);
        advanceFilterConfig.groupBy.selected.push(selectedMenu);
      }
      this.setState({
        advanceFilterConfig
      }, () => {
        this.GetSummaryDetails(data, FromDate, ToDate, msg, type);
      });
    } else {
      this.setState({ isPopupOpen: false, employeeSummary: [], confirmationMessage: '', row: [], expand: false, payPeriod: [], msgTitle: '' }, () => {
        this.resetPage();
      });
    }
  }

  GetSummaryDetails = (data, payPeriodStartDate, payPeriodEndDate, msg, type) => {
    const params = {
      fromDate: moment(payPeriodStartDate).format(DateFormat),
      toDate: moment(payPeriodEndDate).format(DateFormat),
      ssrsCall: 6,
      marketId: data.marketId?.toString(),
      varianceType: type
    };
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Report.GetMarketVaianceDetailData,
        params,
        key: 'marketReimburseData'
      }
    ])
      .then(({ marketReimburseData }) => {
        this._asyncRequest = null;
        if (marketReimburseData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        const payPeriod = [{
          payPeriod: params.payPeriodEndDate,
          isCollapsed: true
        }];
        defaultPayPeriod = payPeriod;
        marketReimburseData.data = marketReimburseData.data.filter(x => x.marketName === data.marketName);

        const rows = this.getMarketTableRow(marketReimburseData.data);

        this.setState({
          rows,
          payPeriod,
          employeeSummary: marketReimburseData.data,
          isPopupOpen: true,
          confirmationMessage: data.marketName + ' details for Pay period ' + moment(params.fromDate).format(DateFormatMMDDYYYY) + '-' + moment(params.toDate).format(DateFormatMMDDYYYY),
          msgTitle: msg
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  getMarketTableRow = (marketReimburseData) => {
    let returnRows = [];
    returnRows = [...returnRows, ...this.renderMarketTableRow(
      orderBy(marketReimburseData, this.state.orderBy, this.state.order)
    )];
    return returnRows;
  }

  renderMarketTableRow = (data) => {
    if (this.state.advanceFilterConfig.suppressZero === true) {
      data = data.filter(x => {
        return _.chain(x.reimbursmentDetails).sumBy(x => x.reimbursementCost).value() !== 0;
      });
    }
    if (this?.state?.advanceFilterConfig?.showSummary !== true) {
      data = _.chain(data).orderBy(this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value), 'asc').value();
    }
    return this.renderMarketReimbursementTableCell(
      getMultilevelGroupedData(data, this.state.advanceFilterConfig.groupBy.selected.map((x) => x.value), true),
      []);
  }

  getColumnSequence = () => {
    if (this.state.advanceFilterConfig.suppressDetails) {
      return removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected], 'key');
    } else {
      return removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected, ...this.state.advanceFilterConfig.groupBy.masterData], 'key');
    }
  }

  adjustColumnSequence = (currentGroupedRow) => {
    this.state.advanceFilterConfig.groupBy.masterData.forEach(x => {
      currentGroupedRow.push({ key: x.value });
    }
    );
    return currentGroupedRow;
  }

  handleClickOpen = () => {
    this.setState({
      openSlidingPanel: true
    });
  };

  resetPage = () => {
    const { advanceFilterConfig } = this.state;
    advanceFilterConfig.summaryRows = false;
    advanceFilterConfig.suppressZero = false;
    advanceFilterConfig.suppressDetails = false;
    advanceFilterConfig.groupBy = {
      masterData: [
        {
          key: 'Department',
          id: 'departmentName',
          value: 'departmentName',
          ssrsReport: 'DepartmentName',
          numeric: false,
          disablePadding: false,
          label: 'Employee',
          type: 'Text',
          order: 2
        },
        {
          key: 'Division',
          id: 'division',
          value: 'division',
          ssrsReport: 'Division',
          numeric: false,
          disablePadding: false,
          label: 'Division',
          type: 'Text',
          order: 3
        },
        {
          key: 'Employee',
          value: 'employeeName',
          id: 'employeeName',
          ssrsReport: 'Employee',
          numeric: false,
          disablePadding: false,
          label: 'Employee',
          type: 'Text',
          order: 4
        },
        {
          key: 'Expense Group',
          value: 'expenseGroup',
          id: 'expenseGroup',
          ssrsReport: 'ExpenseGroup',
          numeric: false,
          disablePadding: false,
          label: 'Expense Group',
          type: 'Text',
          order: 5
        },
        {
          key: 'Expense Name',
          value: 'expenseName',
          id: 'expenseName',
          ssrsReport: 'ExpenseName',
          numeric: false,
          disablePadding: false,
          label: 'Expense Name',
          type: 'Text',
          order: 6
        }],
      selected: [{
        key: 'Market',
        value: 'marketName',
        id: 'marketName',
        ssrsReport: 'MarketName',
        numeric: false,
        disablePadding: false,
        label: 'Market',
        type: 'Text',
        order: 1
      }]
    };
    this.setState({
      advanceFilterConfig
    });
  };

  renderMarketReimbursementTableCell = (groupedData, currentGroupedRow = [], tableCell = [], rowCount = 0) => {
    const showSummary = this.state.advanceFilterConfig.summaryRows;
    const suppressDetails = this.state.advanceFilterConfig.suppressDetails;
    const sequence = this.getColumnSequence();
    let column1 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[0]?.value) || {}).value ?? '' : '';
    let column2 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[1]?.value) || {}).value ?? '' : '';
    let column3 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[2]?.value) || {}).value ?? '' : '';
    let column4 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[3]?.value) || {}).value ?? '' : '';
    let column5 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[4]?.value) || {}).value ?? '' : '';
    let column6 = showSummary ? (currentGroupedRow.find(x => x.key === sequence[5]?.value) || {}).value ?? '' : '';

    const payPeriod = defaultPayPeriod;
    groupedData.forEach((d, i) => {
      if (d.data !== undefined) {
        // rowCount = 0;
        currentGroupedRow = currentGroupedRow.filter(x => x.key !== d.key);
        currentGroupedRow.push({ key: d.key, value: d[d.key] });
        if (this.state.advanceFilterConfig.summaryRows === false) {
          this.renderMarketReimbursementTableCell(d.data, currentGroupedRow, tableCell, rowCount);
        }
      }
      const keyvalue = this.adjustColumnSequence(_.cloneDeep(currentGroupedRow));
      if (d.reimbursmentDetails) {
        const evenOddClass =
          tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
        const topBorderClass =
          column1 !== (keyvalue.find(x => x.key === sequence[0]?.value) || {}).value ?? '' ? ' rpt-topBorder ' : ' ';
        const key = rowCount + '_' + i;
        if (d.reimbursmentDetails.length > 0 && (d.reimbursmentDetails[0].isSummary === undefined ||
          (d.reimbursmentDetails.length > 0 && d.reimbursmentDetails[0].isSummary === true &&
            this.state.advanceFilterConfig.summaryRows === true))) {
          if ((suppressDetails && d.isGroup) || (!suppressDetails)) {
            tableCell.push(
              <TableRow
                className={(this.state.advanceFilterConfig.summaryRows === true ? topBorderClass : '') + (d.isGroup === true ? ' parent-row' : '')}
              >{(!suppressDetails || (suppressDetails && sequence[0]?.value !== '')) && (
                <TableCell
                  className={'st sticky ' + evenOddClass + (column1 !== d[sequence[0]?.value] &&
                    ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[0]?.value])
                    ? topBorderClass
                    : '')}
                >
                  {getFormattedValues(column1 !== d[sequence[0]?.value] && d[sequence[0]?.value], 'Text')}{' '}
                </TableCell>
              )
                }
                {(!suppressDetails || (suppressDetails && sequence[1]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-1 ' +
                      evenOddClass +
                      (column2 !== d[sequence[1]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[1]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {d.isGroup === true && getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[1]?.value)}</span>
                      : (getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text') === null ? <span className='total-count'>-</span> : getFormattedValues(column2 !== d[sequence[1]?.value] && d[sequence[1]?.value], 'Text'))}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[2]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-2 ' +
                      evenOddClass +
                      (column3 !== d[sequence[2]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[2]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {d.isGroup === true && getFormattedValues(column3 !== d[sequence[2]?.value] && d[sequence[2]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[2]?.value)}</span>
                      : getFormattedValues(column3 !== d[sequence[2]?.value] && d[sequence[2]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[3]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-3 ' +
                      evenOddClass +
                      (column4 !== d[sequence[3]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[3]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {d.isGroup === true && getFormattedValues(column4 !== d[sequence[3]?.value] && d[sequence[3]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[3]?.value)}</span>
                      : getFormattedValues(column4 !== d[sequence[3]?.value] && d[sequence[3]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[4]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-4 ' +
                      evenOddClass +
                      (column5 !== d[sequence[4]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[4]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {d.isGroup === true && getFormattedValues(column5 !== d[sequence[4]?.value] && d[sequence[4]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[4]?.value)}</span>
                      : getFormattedValues(column5 !== d[sequence[4]?.value] && d[sequence[4]?.value], 'Text')}
                  </TableCell>
                )
                }
                {(!suppressDetails || (suppressDetails && sequence[5]?.value !== '')) && (
                  <TableCell
                    className={
                      'st sticky-5 ' +
                      evenOddClass +
                      (column6 !== d[sequence[5]?.value] &&
                        ((this.state.advanceFilterConfig.summaryRows === true && d.isGroup) || d[sequence[5]?.value])
                        ? ' rpt-topBorder '
                        : ' ')
                    }
                  >
                    {d.isGroup === true && getFormattedValues(column6 !== d[sequence[5]?.value] && d[sequence[5]?.value], 'Text').props.children?.toString() === '-'
                      ? <span className='total-count'>{this.getGroupedArray(d, sequence[5]?.value)}</span>
                      : getFormattedValues(column6 !== d[sequence[5]?.value] && d[sequence[5]?.value], 'Text')}
                  </TableCell>
                )
                }
                {payPeriod?.map((date, ind) => (
                  this.renderReimbursementColumn(d.reimbursmentDetails, date, key + ind, evenOddClass, d)
                ))}
              </TableRow>
            );
          }
        }
        rowCount++;
        column1 = (keyvalue.find(x => x.key === sequence[0]?.value) || {}).value ?? '';
        column2 = (keyvalue.find(x => x.key === sequence[1]?.value) || {}).value ?? '';
        column3 = (keyvalue.find(x => x.key === sequence[2]?.value) || {}).value ?? '';
        column4 = (keyvalue.find(x => x.key === sequence[3]?.value) || {}).value ?? '';
        column5 = (keyvalue.find(x => x.key === sequence[4]?.value) || {}).value ?? '';
        column6 = (keyvalue.find(x => x.key === sequence[5]?.value) || {}).value ?? '';
      }
      if (d.data !== undefined && this.state.advanceFilterConfig.summaryRows === true && d.isGroup === true) {
        this.renderMarketReimbursementTableCell(d.data, currentGroupedRow, tableCell, rowCount);
      }
    });
    return tableCell;
  };

  renderReimbursementColumn = (reimbursementDetails, payPeriod, index, evenOddClass, d) => {
    const reimbursementDetail = reimbursementDetails;
    const isSensitiveData = IsSensitiveDataAccess();

    const tableCell = [];
    tableCell.push(<>
      {(payPeriod.isCollapsed === false || !isSensitiveData) && (
        <>
          <TableCell className={(evenOddClass + 'rpt-topBorder')} key={index + 'allocationRate'}>
            {
              reimbursementDetail.map((reimburse, ind) =>
                <div key={index + 'allocationRate' + ind} className={((reimbursementDetail.length) > 1 &&
                  ind !== (reimbursementDetail.length - 1))
                  ? 'multi-pay-period'
                  : ''}>
                  {d.isGroup === true && reimburse.allocationRate === undefined
                    ? <span className='total-count'>{this.getGroupedArray(reimburse, reimburse.allocationRate)}</span>
                    : (reimburse.allocationRate === null || isNaN(parseFloat(reimburse.allocationRate)))
                      ? <span className="number-text">-</span>
                      : (parseFloat(reimburse.allocationRate) >= 0
                        ? <span className={this.state.expand === true ? 'report-percent-allocation-rate-expanded' : 'report-percent-text-rate'}>{numberWithCommas(with2DecimalsPoints(parseFloat(reimburse.allocationRate), 'Percent'))}%</span>
                        : <span className={this.state.expand === true ? 'report-percent-allocation-rate-expanded' : 'report-percent-text-rate'}>({numberWithCommas(with2DecimalsPoints(parseFloat(Math.abs(reimburse.allocationRate)), 'Percent'))})%</span>
                      )
                  }
                </div>
              )
            }
          </TableCell>
        </>)
      }
      {
        (payPeriod.isCollapsed === false && isSensitiveData) && (
          <TableCell className={(evenOddClass + 'rpt-topBorder')} key={index + 'expenseAmount'}>
            {
              reimbursementDetail.map((reimburse, ind) =>
                <div key={index + 'expenseAmount' + ind} className={((reimbursementDetail.length) > 1 &&
                  ind !== (reimbursementDetail.length - 1))
                  ? 'multi-pay-period'
                  : ''}>
                  {(reimburse.expenseAmount === null || isNaN(parseFloat(reimburse.expenseAmount)))
                    ? <span className="number-text">-</span>
                    : (parseFloat(reimburse.expenseAmount) >= 0
                      ? <span className={this.state.expand === true ? 'report-percent-allocation-rate-expanded' : 'report-percent-text-rate'}>${numberWithCommas(with2DecimalsPoints(parseFloat(reimburse.expenseAmount), 'Percent'))}</span>
                      : <span className={this.state.expand === true ? 'report-percent-allocation-rate-expanded' : 'report-percent-text-rate'}>$({numberWithCommas(with2DecimalsPoints(parseFloat(Math.abs(reimburse.expenseAmount)), 'Percent'))})</span>)
                  }
                </div>
              )
            }
          </TableCell>
        )
      }
      {isSensitiveData
        ? <TableCell className={(evenOddClass + 'right-border  rpt-topBorder')} key={index + 'reimbursementCost'}>
          {
            reimbursementDetail.map((reimburse, ind) =>
              <div key={index + 'reimbursementCost' + ind} className={((reimbursementDetail.length) > 1 &&
                ind !== (reimbursementDetail.length - 1))
                ? 'multi-pay-period'
                : ''}>
                {(reimburse.reimbursementCost === null || isNaN(parseFloat(reimburse.reimbursementCost)))
                  ? <span className="number-text">-</span>
                  : (parseFloat(reimburse.reimbursementCost) >= 0
                    ? <span className={this.state.expand === true ? 'report-percent-text-rate-expanded' : 'report-percent-text-cost'}>${numberWithCommas(with2DecimalsPoints(parseFloat(reimburse.reimbursementCost), 'Percent'))}</span>
                    : <span className={this.state.expand === true ? 'report-percent-text-rate-expanded' : 'report-percent-text-cost'}>$({numberWithCommas(with2DecimalsPoints(parseFloat(Math.abs(reimburse.reimbursementCost)), 'Percent'))})</span>
                  )
                }
              </div>
            )
          }
        </TableCell>
        : ''}
    </>);
    return tableCell;
  }

  getGroupedArray(d, key) {
    // return [...new Set(d.data.map(x => x[key]))].length;
    return '';
  }

  onAddvanceFilterChange = (advanceFilterConfig) => {
    this.setState({
      advanceFilterConfig: advanceFilterConfig,
      openSlidingPanel: false

    }, () => {
      const rows = this.getMarketTableRow(this.state.employeeSummary || []);
      this.setState({
        rows
      });
    });
  }

  getSupprssDetailsColumnCount = () => {
    if (this.state.advanceFilterConfig.suppressDetails) {
      const columns = [];
      const allColumns = removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected, ...this.state.advanceFilterConfig.groupBy.masterData], 'key');
      const selectedColumns = removeDuplicates([...this.state.advanceFilterConfig.groupBy.selected], 'key');
      const diffColumns = allColumns.length - selectedColumns.length;
      for (let c = 0; c < diffColumns; c++) {
        columns.push(c + 1);
      }
      return columns;
    } else {
      return [];
    }
  }

  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    let rows = [];
    rows = [...rows, ...this.getMarketTableRow(
      orderBy((this.state.employeeSummary || []), property, isAsc ? 'desc' : 'asc')
    )];
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property,
      rows
    }, () => { this.forceUpdate(); });
  };

  onClickOnArrow = (payPeriod, isCollapsed) => {
    const collapsePayPeriod = (this.state.payPeriod || []);
    collapsePayPeriod.find(d => d.payPeriod === payPeriod).isCollapsed = !isCollapsed;
    defaultPayPeriod = collapsePayPeriod;
    const rows = this.getMarketTableRow(this.state.employeeSummary || []);
    this.setState({
      payPeriod: collapsePayPeriod,
      handleCollapse: !this.state.handleCollapse,
      rows
    }, () => { this.forceUpdate(); });
  }

  expandAll = (e) => {
    const collapsePayPeriod = (this.state.payPeriod || []);

    (collapsePayPeriod.filter(d => d.isCollapsed === e.target.checked) || []).forEach((x) => {
      x.isCollapsed = !e.target.checked;
    });
    defaultPayPeriod = collapsePayPeriod;
    const rows = this.getMarketTableRow(this.state.employeeSummary || []);
    this.setState({
      expand: e.target.checked,
      payPeriod: collapsePayPeriod,
      rows
    });
  }

  renderMarketReimbursementTable = (rows) => {
    const groupSequence = this.getColumnSequence();
    const suppressColumns = this.getSupprssDetailsColumnCount();
    const isSensitiveData = IsSensitiveDataAccess();
    const { payPeriod } = this.state;
    const collapsableObj = isSensitiveData ? collapsableReimbursement : collapsableAllocationPercent;
    const extendibleArray = isSensitiveData ? extendibleMarkerReimbursArray : [collapsableAllocationPercent];

    return (
      <Table className="reportTable" id="rptTable">
        <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          rowCount={rows.length}
          columnSequence={groupSequence}
          headCells={[]}
          payPeriod={payPeriod}
          isMarket={true}
          isSensitiveData={isSensitiveData}
          dynamicColumnCount={[1, 2, 3, 4, 5]}
          suppressDetailsColumnCount={suppressColumns}
          extendibleArray={extendibleArray}
          collapsableObj={collapsableObj}
          onClickOnArrow={this.onClickOnArrow}
          expand={this.state.expand}
          expandAll={this.expandAll}
          suppressDetails={this.state.advanceFilterConfig.suppressDetails}
        />
        <TableBody>{rows}</TableBody>
      </Table>
    );
  };

  render() {
    const {
      showMain,
      marketMasterData,
      marketReimburseData,
      empSummaryRows,
      showReport,
      isPopupOpen,
      confirmationMessage,
      msgTitle,
      rows,
      expand,
      handleCollapse,
      advanceFilterConfig,
      openSlidingPanel,
      employeeSummary
    } = this.state;

    if (marketMasterData.find(x => x.marketName === 'All') === undefined) {
      marketMasterData.unshift({ marketName: 'All' });
    }
    return (
      <>
        {isPopupOpen && (
          <Dialog open={isPopupOpen} maxWidth="xl" fullWidth={true} >
            <AppBar
              style={{ position: 'relative', backgroundColor: '#064473' }}
            >
              <Toolbar>
                <Typography
                  variant="h6"
                  className="app-header-white"
                  style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
                >
                  {confirmationMessage}
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="close"
                  style={{ paddingLeft: '40px' }}
                >
                  <IoMdCloseCircleOutline onClick={() => { this.onPopupClickHandle(false); }}
                  />
                </IconButton>
              </Toolbar>
            </AppBar>
            <DialogContent dividers>
              <DialogContentText style={{ color: '#002f6c' }}>
                <label> <b> {msgTitle} </b> </label>
              </DialogContentText>
              <Grid container className="no-print row top-xs end-xs" style={{ marginTop: '-40px' }}>
                <ReportButtons
                  handleSubmit={this.handleSubmit}
                  handleClickOpen={this.handleClickOpen}
                  data={employeeSummary}
                  hideAdvanceFilter={true}
                  hideButtons={true}
                />
              </Grid>
              <div className="col-lg-3 buttons">
                <div className="col-lg-12">
                  <AdvancedFilter
                    filterConfig={advanceFilterConfig}
                    onApplyFilter={this.onAddvanceFilterChange}
                    openSlidingPanel={openSlidingPanel}
                    handleClose={this.handleClose}
                  />
                </div>
              </div>
              <DialogContentText>
                <TableWithPaginations
                  tableData={rows}
                  renderTable={this.renderMarketReimbursementTable}
                  expand={expand}
                  order={this.state.order}
                  oBy={this.state.orderBy}
                  handleCollapse={handleCollapse}
                />
              </DialogContentText>
            </DialogContent>

          </Dialog>
        )}
        {showMain
          ? (
            <Reports />
          )
          : (
            <>
              <PageHeader
                key={'Market_Variance_Detail_Report'}
                title={'Market Variance Detail Report'}
                style={{ marginLeft: '1rem' }}
                actionsConfig={[
                  {
                    icon: (
                      <ArrowBackIcon
                        size="small"
                        className="back-button no-print"
                      />
                    ),
                    onClick: this.goBack,
                    title: 'Back to Report'
                  }
                ]}
              >
                Market Variance Detail Report
                  </PageHeader>
              <Grid container className="no-print row top-xs end-xs">
                <ReportButtons
                  handlePrintClick={this.handlePrintClick}
                  downloadFile={this.handleExport}
                  data={marketReimburseData}
                  hideAdvanceFilter={true}
                  hideAdvanceLink={true}
                  hideButtons={false}
                />
              </Grid>
              {showReport &&
                marketReimburseData !== null &&
                marketReimburseData.length > 0 && (
                  <TableContainer
                    component={Paper}
                    style={{ maxWidth: '100vw' }}
                  >
                    {this.renderTable(empSummaryRows)}
                  </TableContainer>
                )}
              {showReport &&
                (marketReimburseData == null ||
                  marketReimburseData.length <= 0) && (
                  <Grid container spacing={4}>
                    <Grid
                      container
                      direction="row-reverse"
                      justify="center"
                      alignItems="stretch"
                    >
                      <label className="item-big">No Data Available.</label>
                    </Grid>
                  </Grid>
                )}
            </>
          )}
      </>
    );
  }
}
